<template>
    <div class="section-box" v-loading="loading">
        <div class="steps-source">
            <h3>商机进度</h3>
            <div class="steps">
                <i class="divider"></i>
                <div class="step">
                    <span class="icon iconfont icon-danxun"></span>
                    <div>
                        <el-button round size="small" :disabled="businessProgCBJQ != null || businessProgSD != null" :class='{"selected":businessProgCBJQ}' @click="configProgModi(1)">初步接洽</el-button>
                    </div>
                    <template v-if="businessProgCBJQ">
                        <div class="step-operator">{{businessProgCBJQ.principal}}</div>
                        <div class="step-date">{{businessProgCBJQ.createTime}}</div>
                    </template>
                </div>
                <div class="step">
                    <span class="icon iconfont icon-danxun"></span>
                    <div>
                        <el-button round size="small" :disabled="businessProgXQQD != null || businessProgSD != null" :class='{"selected":businessProgXQQD}' @click="configProgModi(2)">需求确定</el-button>
                    </div>
                    <template v-if="businessProgXQQD">
                        <div class="step-operator">{{businessProgXQQD.principal}}</div>
                        <div class="step-date">{{businessProgXQQD.createTime}}</div>
                    </template>
                </div>
                <div class="step">
                    <span class="icon iconfont icon-danxun"></span>
                    <div>
                        <el-button round size="small" :disabled="businessProgYXFD != null || businessProgSD != null" :class='{"selected":businessProgYXFD}' @click="configProgModi(3)">意向发单</el-button>
                    </div>
                    <template v-if="businessProgYXFD">
                        <div class="step-operator">{{businessProgYXFD.principal}}</div>
                        <div class="step-date">{{businessProgYXFD.createTime}}</div>
                    </template>
                </div>
                <div class="step">
                    <span class="icon iconfont icon-danxun"></span>
                    <div>
                        <el-button round size="small" @click="winSingleButton" :disabled="businessProgYD != null || businessProgSD != null" :class='{"selected":businessProgYD}'>赢单</el-button>
                        <el-button round size="small" @click="loseShow=true" :disabled="businessProgSD != null || businessProgYD != null" :class='{"selected":businessProgSD}'>输单</el-button>
                    </div>
                    <template v-if="businessProgYD">
                        <div class="step-operator">{{businessProgYD.principal}}</div>
                        <div class="step-date">{{businessProgYD.createTime}}</div>
                    </template>
                    <template v-if="businessProgSD">
                        <div class="step-operator">{{businessProgSD.principal}}</div>
                        <div class="step-date">{{businessProgSD.createTime}}</div>
                    </template>
                </div>
            </div>
        </div>
        <div style="margin-top: 30px;">
            <el-row :gutter="24">
                <el-col :span="11">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>商机信息</span>
                            <template v-if="isEdit">
                                <el-button style="float: right; padding: 3px 0;" type="text" @click="onSaveBasicInfo">保存</el-button>
                            </template>
                            <template v-else>
                                <template v-if="!(typeof(actionData.customersjlb_delete) != 'undefined'&&!actionData.customersjlb_delete)">
                                <el-popconfirm
                                    confirm-button-text='确定'
                                    cancel-button-text='取消'
                                    icon="el-icon-info"
                                    icon-color="red"
                                    :title="'是否将商机【'+ form.businessName +'】删除？'"
                                    @confirm="deleteBusiness"
                                >
                                    <el-button style="float: right; padding: 3px 0;color: #f75959;" slot="reference" type="text">删除</el-button>
                                </el-popconfirm>
                                </template>
                                <template v-if="!(typeof(actionData.customersjlb_edit) != 'undefined'&&!actionData.customersjlb_edit)">
                                    <el-button style="float: right; padding: 3px 0;margin-right: 20px;" type="text" @click="onEditBasicInfo">编辑</el-button>
                                </template>
                            </template> 
                        </div>
                        <div>
                            <BasicInfo ref="basicInfo" @confirmBasicInfo="saveBasicInfo"/>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="11" :offset="2">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>跟进记录</span>
                            <el-button style="float: right; padding: 3px 0" type="text" @click="recordShow=true">写跟进</el-button>
                        </div>
                        <div class="dealer-message-list">
                            <div class="dealer-message-item" v-for="(item,index) in followUp" :key="index">
                                <div class="item-date">{{item.createDate.split(" ")[0]}}</div>
                                <div class="item-principal">
                                    <div>{{item.createMan || '--'}}</div>
                                    <!-- <div>10:31</div> -->
                                </div>
                                <div class="item-describe">{{item.description}}</div>
                                <div class="item-next-date" v-if="item.nextTraceDate">下次跟进日期：{{item.nextTraceDate.substr(0,10)}}</div>
                                <el-divider content-position="right">{{item.createDate.split(" ")[1]}}</el-divider>
                            </div>
                            <div v-if="!followUp.length">
                                <div style="text-align: center;line-height: 200px;color: #999999;font-size: 14px;">暂无跟进数据</div>
                            </div>
                        </div>
                    </el-card>
                    <el-card v-if="businessProgSD" class="box-card" shadow="hover" style="margin-top: 30px;">
                        <div slot="header" class="clearfix">
                            <span>结果</span>
                        </div>
                        <div class="dealer-message-list">
                            <div class="item-result">输单</div>
                            <div class="item-describe">{{form.loseReason}}</div>
                            <div class="lose-position-icon"></div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog
            title="输单原因"
            :visible.sync="loseShow"
            :close-on-click-modal="false"
            width="600px"
        >
            <!-- :before-close="loseClose" -->
            <el-form label-width="100px">
                <el-form-item label=" ">
                    <div>是否将【{{form.businessName}}】调整为输单？</div>
                </el-form-item>
                <el-form-item label="输单描述：" required>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2}"
                        placeholder="请输入内容"
                        v-model="loseReason">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="loseSingleButton">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog 
            title="跟进内容" 
            :visible.sync="recordShow" 
            :close-on-click-modal="false"
            width="600px" 
            ref="dialog" 
        >
            <!-- @close="recordClose" -->
            <el-form label-width="120px">
                <el-form-item label="下次跟进日期：" >
                    <el-date-picker
                        v-model="nextTime"
                        type="date"
                        style="width: 100%"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="跟进描述：" required class="word-limit">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2}"
                        placeholder="请输入内容"
                        v-model="description"
                        maxlength="1000"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary">提交</el-button>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="configFollowUpButton">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import { getStorageUserRoleId, getActionData } from '@/utils/store'
    import { mapActions } from "vuex";
    import {
        basicDetails,                   //基本信息包含商机进度
        addBusinessOrModi,              //修改|新增
        businessDel,                    //删除
        progModi,                       //商机进度编辑
        addFollowUpOrModi,              //写跟进
        followUpList,                       //获取跟进记录
    } from "@/service/customerInformation";
    import BasicInfo from './index/dealerBasicInfo'
    export default {
        components: {
            BasicInfo
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(!vm.$route.query.pkid) {
                    vm.$message.warning('缺少商机id')
                    setTimeout(() => {
                        vm.removeTabList({
                            id: vm.$route.meta.menuId,
                        })
                        vm.$router.push('/customer/dealerList')
                    }, 300)
                }else{
                    vm.pkid = vm.$route.query.pkid
                    vm.isEdit = false
                    vm.businessProgCBJQ = null
                    vm.businessProgXQQD = null
                    vm.businessProgYXFD = null
                    vm.businessProgYD = null
                    vm.businessProgSD = null
                    vm.form = {}
                    vm.loseReason = ''
                    vm.recordShow = false
                    vm.loseShow = false
                    vm.description = ''
                    vm.nextTime = '';
                    vm.getBasicInfo();
                    vm.getFollowUpList();
                }
            })
        },
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                loading: false,
                pkid: '',
                isEdit: false,
                form: {},
                recordShow: false,
                loseShow: false,
                // createDate: new Date(),

                businessProgCBJQ: null,           //商机进度初步接洽
                businessProgXQQD: null,           //商机进度需求确定
                businessProgYXFD: null,           //商机进度意向发单
                businessProgYD: null,           //商机进度赢单
                businessProgSD: null,           //商机进度输单

                loseReason: '',                 //输单原因
                description: '',                //跟进内容
                nextTime:'',                    //下次跟进时间
                followUp: [],                   //跟进列表
            };
        },
        methods: {
            ...mapActions('app', [
                'removeTabList'
            ]),
            //获取商机进度
            configProgModi(id){
                let data = {
                    businessProgId: id,
                    loseReason: this.loseReason,
                    pkid: this.pkid,
                    updateManId: getStorageUserRoleId()
                }
                !data.loseReason && delete data.loseReason
                progModi(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    res.Data.map(obj=> {
                        switch (obj.businessProgId) {
                            case 1:
                                this.businessProgCBJQ = obj
                                break;
                            case 2:
                                this.businessProgXQQD = obj
                                break;
                            case 3:
                                this.businessProgYXFD = obj
                                break;
                            case 4:
                                this.businessProgYD = obj
                                break;
                            default:
                                this.businessProgSD = obj
                                break;
                        }
                    })
                    if(this.loseShow) {
                        this.loseShow = false
                        this.getBasicInfo();
                    }
                })
            },
            // 点击赢单
            winSingleButton(){
                if(!this.businessProgCBJQ || !this.businessProgXQQD || !this.businessProgYXFD) {
                    return this.$message.warning('请依次确认初步接洽、需求确定、意向发单！')
                }
                this.$confirm('是否确认此商机已赢单？', '赢单确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    showCancelButton: false,
                }).then(() => {
                    this.configProgModi(4)
                }).catch(() => {
                    console.log('取消')      
                });
            },
            // 点击输单dialog确定
            loseSingleButton(){
                if(!this.loseReason) {
                    return this.$message.warning('请输入输单描述')
                }
                this.configProgModi(5)
            },
            // 获取用户基本信息
            getBasicInfo(){
                let data = {
                    pkid: this.pkid
                }
                this.loading = true;
                basicDetails(data).then(res=> {
                    this.loading = false;
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    if(res.Data.progRecord.length) {
                        res.Data.progRecord.map(obj=> {
                            switch (obj.businessProgId) {
                                case 1:
                                    this.businessProgCBJQ = obj
                                    break;
                                case 2:
                                    this.businessProgXQQD = obj
                                    break;
                                case 3:
                                    this.businessProgYXFD = obj
                                    break;
                                case 4:
                                    this.businessProgYD = obj
                                    break;
                                default:
                                    this.businessProgSD = obj
                                    break;
                            }
                        })
                    }
                    this.form = res.Data
                    this.isEdit = false
                    this.$refs.basicInfo.getDealerBasicInfo(this.form, this.isEdit)
                })
            },
            // 点击基本信息编辑
            onEditBasicInfo(){
                this.isEdit = true
                this.$refs.basicInfo.editDealerBasicInfo(this.form, this.isEdit)
            },
            // 点击保存基本信息
            onSaveBasicInfo(){
                this.$refs.basicInfo.saveBasicInfo()
            },
            // 保存回调接口
            saveBasicInfo(data){
                addBusinessOrModi(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('保存成功！')
                    this.isEdit = false
                    this.getBasicInfo();
                })
            },
            // 删除商机
            deleteBusiness(){
                let data = {
                    pkid: this.pkid
                }
                businessDel(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    setTimeout(() => {
                        this.removeTabList({
                            id: this.$route.meta.menuId,
                        })
                        this.$router.push('/customer/dealerList')
                    }, 300)
                })
            },
            //添加跟进
            configFollowUpButton(){
                let data = {
                    businessId: this.pkid,
                    description: this.description,
                    createManId: getStorageUserRoleId(),
                    updateNamId: getStorageUserRoleId(),
                    nextTraceDate:this.nextTime?this.nextTime+' 00:00:00':null,
                }
                if(!data.description) {
                    return this.$message.warning('请输入跟进描述')
                }
                addFollowUpOrModi(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.recordShow = false
                    this.description = ''
                    this.$message.success('添加成功！')
                    this.getFollowUpList()
                })
            },
            // 获取跟进记录
            getFollowUpList(){
                let data = {
                    businessId: this.pkid,
                    rational: false,
                }
                followUpList(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.followUp = res.Data.datas
                })
            },
            // 关闭跟进内容
            // recordClose(){
            //     this.recordShow = false;
            //     this.createDate = new Date()
            // }
        },
    }
</script>
<style lang="scss">
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
    .steps-source {
        background: #F9F9F9;
        border: 1px solid #E5E5E5;
        padding: 0 24px 22px 24px;
        h3 {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            line-height: 24px;
            padding: 14px 0;
        }
        .steps {
            display: flex;
            justify-content: space-around;
            position: relative;
            .divider {
                position: absolute;
                top: 7px;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: #dcdfe6;
                
            }
            .step {
                position: relative;
                z-index: 2;
                text-align: center;
                width: 25%;
                >div {
                    margin-top: 16px;
                }
                .icon-danxun {
                    color: #409eff;
                }
            }
            .step-operator {
                font-size: 14px;
                color: #333333;
            }
            .step-date {
                margin-top: 4px !important;
                font-size: 14px;
                color: #666666;
            }
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
            &:hover {
                color: #409EFF;
                background: #ecf5ff;
                border-color: #c6e2ff;
            }
        }
    }
    .dealer-message-list {
        position: relative;
        min-height: 120px;
        .dealer-message-item{ 
            padding-bottom: 20px;
        }
        .item-date {
            font-size: 20px;
            color: #333333;
            padding-bottom: 10px;
        }
        .item-principal {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 20px;
            color: #333333;
            line-height: 24px;
            padding-bottom: 10px;
        }
        .item-describe {
            font-size: 14px;
            color: #666666;
            min-height: 38px;
        }
        .item-next-date{
            font-size: 14px;
            color: #666666;
            line-height: 24px;
        }
        .item-result {
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            padding-bottom: 10px;
            font-weight: 600;
        }
        .el-divider{
            margin-top: 10px !important;
        }
        .lose-position-icon {
            width: 114px;
            height: 104px;
            background-image: url('../../assets/images/icon-lose.png');
            background-repeat: no-repeat;
            position: absolute;
            right: -50px;
            top: -100px;
        }
    }
    .word-limit {
        .el-input__count {
            line-height: 22px;
        }
    }
</style>